import { render, staticRenderFns } from "./AssistantPdfPrinter.vue?vue&type=template&id=3f5de660&scoped=true&"
import script from "./AssistantPdfPrinter.vue?vue&type=script&lang=ts&"
export * from "./AssistantPdfPrinter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5de660",
  null
  
)

export default component.exports